import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AreaGuides() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/areas").then((r) => setItems(r.data.items)); }, []);
  return (
    <div className="p-10" data-testid="admin-areas">
      <div className="mb-8">
        <div className="text-xs tracking-[0.24em] uppercase text-gray-500 mb-1">Content</div>
        <h1 className="font-serif text-4xl">Area guides</h1>
      </div>
      <div className="border border-[#E5E7EB] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-[#E5E7EB] text-left uppercase text-xs tracking-wider text-gray-500">
            <tr>
              <th className="px-4 py-3">Community</th>
              <th className="px-4 py-3">Slug</th>
              <th className="px-4 py-3">Avg apt (AED/sqft)</th>
              <th className="px-4 py-3">Rental yield</th>
              <th className="px-4 py-3">Published</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E5E7EB]">
            {items.map((a) => (
              <tr key={a.slug} data-testid={`area-row-${a.slug}`}>
                <td className="px-4 py-3 font-medium">{a.name}</td>
                <td className="px-4 py-3 text-gray-500">/{a.slug}</td>
                <td className="px-4 py-3">{a.average_price_apartment || "—"}</td>
                <td className="px-4 py-3">{a.rental_yield ? `${a.rental_yield}%` : "—"}</td>
                <td className="px-4 py-3">{a.published ? "Yes" : "No"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-sm text-gray-500 mt-6">Area guide editor UI is on the roadmap. For now, guides are seeded and editable via API.</p>
    </div>
  );
}
